/**
 * @fileoverview Supabase client and helper functions
 * @version 1.0.0
 * @created 2026-02-02
 * @description Unified Supabase implementation for ZIPLINE-CMS
 *              OAuth (Google) + Email/Password authentication with session management
 */

// Browser clients (client-side only)
export { createCSRClient } from "./client";

// Server clients (server-side only)
export { createAnonClient, createRoleClient, createSSRClient, createAPIClient, createMiddlewareClient } from "./server";

// Helper functions (server-side)
export { executeRPC, getProfileById } from "./helpers";
